import { createSlice } from '@reduxjs/toolkit'

// import { FALSE } from 'sass'
const slice = createSlice({
  name: 'storeManagement',
  initialState: {
    //Store Roles
    roleList: [],
    roleListLoading: false,
    updateRole: false,
    rolePaginationData: {},

    // Store type
    storeTypeList: [],
    storeTypeListLoading: false,
    storeTypeListPaginationData: {},
    updateStoreTypes: false,
    getStoreTypesDetails: {},
    getStoreTypesDetailsLoading: false,

    // store Category
    storeCategoryListLoading: false,
    storeCategoryList: [],
    storeListPaginationData: {},
    // store Category Details
    getStoreCategoryDetailsLoading: false,
    getStoreCategoryDetails: [],
    updateStoreCategory: false,

    // store Sub Categories
    storeSubListLoading: false,
    storeSubCategoryListLoading: false,
    storeSubCategoryList: [],
    storeSubCategoryListPaginationData: {},

    // store Sub Category Details
    getStoreSubCategoryDetails: {},
    getStoreSubCategoryDetailsLoading: false,
    updateStoreSubCategory: false,

    //child Sub Category
    storeChildSubCategoryListLoading: false,
    storeChildSubCategoryList: [],
    storeChildSubCategoryListPaginationData: {},

    // SUb Child Category

    getStoreChildSubCategoryDetails: [],
    getStoreChildSubCategoryDetailsLoading: false,
    updateStoreChildSubCategory: false,

    // Brand
    brandListLoading: false,
    brandList: [],
    brandListPaginationData: {},
    updateBrandList: false,

    // Brands Deatils

    brandDetails: [],
    brandDetailsLoading: false,

    // store group
    storeGroupListLoading: false,
    storeGroupList: [],
    storeGroupListPaginationData: {},
    updateStoreGroups: false,

    getStoreGroupsDetails: {},
    getStoreGroupsDetailsLoading: false,

    // Store Tag
    storeTagList: [],
    storeTagListLoading: false,
    storeTagListPaginationData: {},
    updateStoreTag: false,

    // Enquiry
    enquiryList: [],
    enquiryListLoading: false,
    enquiryListPaginationData: {},
    enquiryDetails: {},
    enquiryDetailsLoading: false,

    // ================= Video Category =================
    storeVideoCategoryList: [],
    storeVideoCategoryListLoading: false,
    storeVideoCategoryPaginationData: {},
    updateStoreVideoCategory: false,

    // ================= Store Videos =================
    storeVideoList: [],
    storeVideoListLoading: false,
    storeVideoPaginationData: {},
    updateStoreVideo: false,

    videoDetails: {},
    videoDetailsLoading: false,

    // ================= Offer Category =================
    storeOfferCategoryList: [],
    storeOfferCategoryListLoading: false,
    storeOfferCategoryPaginationData: {},

    storeOfferCategoryDetails: {},
    storeOfferCategoryDetailsLoading: false,

    updateStoreOfferCategory: false,

    storeOfferList: [],
    storeOfferListLoading: false,
    storeOfferPaginationData: {},
    // ================= Store Offer Details =================
    storeOfferDetails: {},
    storeOfferDetailsLoading: false,
    updateOfferLoading: false,

    updateOfferSuccess: false,

    offerSubCategoryList: [],
    offerSubCategoryLoading: false,
    offerSubCategoryPaginationData: {},

    updateOfferSubCategory: false,
    offerSubCategoryDetails: {},
    offerSubCategoryDetailsLoading: false,

    // ================= Internship Category =================
    internshipCategoryList: [],
    internshipCategoryListLoading: false,
    internshipCategoryPaginationData: {},

    updateInternshipCategory: false,

    // ================= Internship SubCategory =================
    internshipSubCategoryList: [],
    internshipSubCategoryLoading: false,
    internshipSubCategoryPaginationData: {},

    updateInternshipSubCategory: false,

    // ================= Internship Programs =================
    internshipProgramList: [],
    internshipProgramListLoading: false,
    internshipProgramPaginationData: {},

    internshipProgramDetails: {},
    internshipProgramDetailsLoading: false,

    // ================= Applied Internship =================
    appliedInternshipList: [],
    appliedInternshipLoading: false,
    appliedInternshipPaginationData: {},

    // ================= Skill Program =================

    // Program Types
    skillProgramTypesList: [],
    skillProgramTypesLoading: false,
    skillProgramTypesPagination: {},
    updateSkillProgramTypes: false,

    // Category
    skillCategoryList: [],
    skillCategoryLoading: false,
    skillCategoryPagination: {},
    updateSkillCategory: false,

    // Sub Category
    skillSubCategoryList: [],
    skillSubCategoryLoading: false,
    skillSubCategoryPagination: {},
    updateSkillSubCategory: false,

    skillProgramList: [],
    skillProgramLoading: false,
    skillProgramPagination: {},
    skillProgramDetails: null,
    skillProgramDetailsLoading: false,
    // ================= Applied Skill =================

    appliedSkillList: [],
    appliedSkillLoading: false,
    appliedSkillPagination: {},

    appliedSkillDetails: {},
    appliedSkillDetailsLoading: false,

    // Internship Super Category
    internshipSuperCategoryList: [],
    internshipSuperCategoryLoading: false,
    internshipSuperCategoryPaginationData: {},
    internshipSuperCategoryDetails: {},
    internshipSuperCategoryDetailsLoading: false,
    updateInternshipSuperCategory: false,

    // Skill Super Category
    skillSuperCategoryList: [],
    skillSuperCategoryLoading: false,
    skillSuperCategoryPaginationData: {},
    skillSuperCategoryDetails: {},
    skillSuperCategoryDetailsLoading: false,
    updateSkillSuperCategory: false,

    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    // Store Roles
    storeRolesListApiData: (state, { payload }) => {
      state.roleListLoading = true
    },
    storeRolesListApiSuccess: (state, { payload }) => {
      state.roleListLoading = false
      state.roleList = payload?.payload?.data
      state.rolePaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    storeRolesListApiFailed: (state, { payload }) => {
      state.roleListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add store roles
    addStoreRolesApiData: (state, { payload }) => {
      state.roleListLoading = true
      state.updateRole = false
      state.modalOpen = false
    },
    addStoreRolesApiSuccess: (state, { payload }) => {
      state.updateRole = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.roleListLoading = false
    },
    addStoreRolesApiFailed: (state, { payload }) => {
      state.updateRole = false
      state.roleListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Store Roles
    updateStoreRolesApiData: (state, { payload }) => {
      state.updateRole = false
      state.roleList = state.roleList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreRolesApiSuccess: (state, { payload }) => {
      state.updateRole = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreRolesApiFailed: (state, { payload }) => {
      state.updateRole = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Store type
    getStoreTypeListApiData: (state, { payload }) => {
      state.storeTypeListLoading = true
    },
    getStoreTypeListApiDataSuccess: (state, { payload }) => {
      state.storeTypeListLoading = false
      state.storeTypeList = payload?.payload?.data
      state.storeTypeListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStoreTypeListApiDataFailed: (state, { payload }) => {
      state.storeTypeListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // add Store Type
    addStoreTypeListApiData: (state, { payload }) => {
      state.storeTypeListLoading = true
      state.updateStoreTypes = false
      state.modalOpen = false
    },
    addStoreTypeListApiSuccess: (state, { payload }) => {
      state.updateStoreTypes = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeTypeListLoading = false
    },
    addStoreTypeListApiFailed: (state, { payload }) => {
      state.updateStoreTypes = false
      state.storeTypeListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Update Store Type
    updateStoreTypeListApiData: (state, { payload }) => {
      state.updateStoreTypes = false
      state.storeTypeList = state.storeTypeList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreTypeListApiSuccess: (state, { payload }) => {
      state.updateStoreTypes = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreTypeListApiFailed: (state, { payload }) => {
      state.updateStoreTypes = false
      alert(JSON.stringify(payload, null, 2))
    },
    //delete Store Type
    deleteStoreTypeListApiData: (state, { payload }) => {
      let updatedStoreTypeList = state.storeTypeList?.filter((item) => item.id !== payload?.id)
      state.storeTypeList = updatedStoreTypeList
      state.updateStoreTypes = false
    },
    deleteStoreTypeListApiSuccess: (state, { payload }) => {
      state.updateStoreTypes = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreTypeListApiFailed: (state, { payload }) => {
      state.updateStoreTypes = false
      alert(JSON.stringify(payload, null, 2))
    },
    // details Store type
    getStoreTypeDetailsListApiData: (state, { payload }) => {
      state.getStoreTypesDetailsLoading = true
    },
    getStoreTypeDetailsListApiSuccess: (state, { payload }) => {
      state.getStoreTypesDetails = payload?.payload?.data
      state.getStoreTypesDetailsLoading = false
    },
    getStoreTypeDetailsListApiFailed: (state, { payload }) => {
      state.getStoreTypesDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // store Categories List
    storeCategoryListApiData: (state, { payload }) => {
      state.storeCategoryListLoading = true
    },
    storeCategoryListApiSuccess: (state, { payload }) => {
      state.storeCategoryListLoading = false
      state.storeCategoryList = payload?.payload?.data
      state.storeListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    storeCategoryListApiFailed: (state, { payload }) => {
      state.storeCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // store Categories List Details
    storeCategoryDetailsApiData: (state, { payload }) => {
      state.getStoreCategoryDetailsLoading = true
    },
    storeCategoryDetailsApiSuccess: (state, { payload }) => {
      state.getStoreCategoryDetails = payload?.payload?.data
      state.getStoreCategoryDetailsLoading = false
    },
    storeCategoryDetailsApiFailed: (state, { payload }) => {
      state.getStoreCategoryDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add store in List
    addStoreCategoryApiData: (state, { payload }) => {
      state.storeCategoryListLoading = true
      state.updateStoreCategory = false
      state.modalOpen = false
    },
    addStoreCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeCategoryListLoading = false
    },
    addStoreCategoryApiFailed: (state, { payload }) => {
      state.updateStoreCategory = false
      state.storeCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Update Store Category
    updateStoreCategoryListApiData: (state, { payload }) => {
      state.updateStoreCategory = false
      state.storeCategoryList = state.storeCategoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreCategoryApiFailed: (state, { payload }) => {
      state.updateStoreCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // delete Category
    deleteStoreProductCategoryDataApiData: (state, { payload }) => {
      let updatedStoreTypeList = state.storeCategoryList?.filter((item) => item.id !== payload?.id)
      state.storeCategoryList = updatedStoreTypeList
      state.updateStoreCategory = false
    },
    deleteStoreProductCategoryDataApiSuccess: (state, { payload }) => {
      state.updateStoreCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreProductCategoryDataApiFailed: (state, { payload }) => {
      state.updateStoreCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // store Sub Category List
    storeSubCategoryListApiData: (state, { payload }) => {
      state.storeSubCategoryListLoading = true
    },
    storeSubCategoryListApiSuccess: (state, { payload }) => {
      state.storeSubCategoryListLoading = false
      state.storeSubCategoryList = payload?.payload?.data
      state.storeSubCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    storeSubCategoryListApiFailed: (state, { payload }) => {
      state.storeSubCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // store Sub Category Details
    storeSubCategoryDetailsApiData: (state, { payload }) => {
      state.getStoreSubCategoryDetailsLoading = true
    },
    storeSubCategoryDetailsApiSuccess: (state, { payload }) => {
      state.getStoreSubCategoryDetails = payload?.payload?.data
      state.getStoreSubCategoryDetailsLoading = false
    },
    storeSubCategoryDetailsApiFailed: (state, { payload }) => {
      state.getStoreSubCategoryDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add Sub store Category
    addSubStoreCategoryApiData: (state, { payload }) => {
      state.storeSubCategoryListLoading = true
      state.updateStoreSubCategory = false
      state.modalOpen = false
    },
    addSubStoreCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeSubCategoryListLoading = false
    },
    addSubStoreCategoryApiFailed: (state, { payload }) => {
      state.updateStoreSubCategory = false
      state.storeSubCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Update Store Sub Category
    updateStoreSubCategoryListApiData: (state, { payload }) => {
      state.updateStoreSubCategory = false
      state.storeSubCategoryList = state.storeSubCategoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreSubCategoryListApiSuccess: (state, { payload }) => {
      state.updateStoreSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreSubCategoryListApiFailed: (state, { payload }) => {
      state.updateStoreSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // delete Sub Category Store
    deleteStoreSubProductCategoryApiData: (state, { payload }) => {
      let updatedSubCategoryList = state.storeSubCategoryList?.filter(
        (item) => item.id !== payload?.id,
      )
      state.storeSubCategoryList = updatedSubCategoryList
      state.updateStoreSubCategory = false
    },
    deleteStoreSubProductCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreSubProductCategoryApiFailed: (state, { payload }) => {
      state.updateStoreSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Child SubCategory List
    storeProductSubChildCategoriesListApiData: (state, { payload }) => {
      state.storeChildSubCategoryListLoading = true
    },
    storeProductSubChildCategoriesListApiSuccess: (state, { payload }) => {
      state.storeChildSubCategoryListLoading = false
      state.storeChildSubCategoryList = payload?.payload?.data
      state.storeChildSubCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    storeProductSubChildCategoriesListApiFailed: (state, { payload }) => {
      state.storeChildSubCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    //Child SubCategory List Details
    storeProductSubChildCategoriesItemDetailsApiData: (state, { payload }) => {
      state.getStoreChildSubCategoryDetailsLoading = true
    },
    storeProductSubChildCategoriesItemDetailsApiSuccess: (state, { payload }) => {
      state.getStoreChildSubCategoryDetails = payload?.payload?.data
      state.getStoreChildSubCategoryDetailsLoading = false
    },
    storeProductSubChildCategoriesItemDetailsApiFailed: (state, { payload }) => {
      state.getStoreChildSubCategoryDetails = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add Store Child Sub Category
    addStoreProductChildSubCategoryApiData: (state, { payload }) => {
      state.storeChildSubCategoryListLoading = true
      state.updateStoreChildSubCategory = false
      state.modalOpen = false
    },
    addStoreProductChildSubCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreChildSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeChildSubCategoryListLoading = false
    },
    addStoreProductChildSubCategoryApiFailed: (state, { payload }) => {
      state.updateStoreChildSubCategory = false
      state.storeChildSubCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Update Store Child Sub Category
    updateStoreChildSubCategoryListApiData: (state, { payload }) => {
      state.updateStoreChildSubCategory = false
      state.storeChildSubCategoryList = state.storeChildSubCategoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreChildSubCategoryListApiSuccess: (state, { payload }) => {
      state.updateStoreChildSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreChildSubCategoryListApiFailed: (state, { payload }) => {
      state.updateStoreChildSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Delete Child Category
    deleteStoreProductChildSubCategoryApiData: (state, { payload }) => {
      let updatedChildSubStoreCategoryList = state.storeChildSubCategoryList?.filter(
        (item) => item.id !== payload?.id,
      )
      state.storeChildSubCategoryList = updatedChildSubStoreCategoryList
      state.updateStoreChildSubCategory = false
    },
    deleteStoreProductChildSubCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreChildSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreProductChildSubCategoryApiFailed: (state, { payload }) => {
      state.updateStoreChildSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Admin Brand
    // Brands
    brandListApiData: (state, { payload }) => {
      state.brandListLoading = true
    },
    brandListApiSuccess: (state, { payload }) => {
      state.brandListLoading = false
      state.brandList = payload?.payload?.data
      state.brandListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    brandListApiFailed: (state, { payload }) => {
      state.brandListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Brands details
    brandNameDetailsApiData: (state, { payload }) => {
      state.brandDetailsLoading = true
    },
    brandNameDetailsApiSuccess: (state, { payload }) => {
      state.brandDetails = payload?.payload?.data
      state.brandDetailsLoading = false
    },
    brandNameDetailsApiFailed: (state, { payload }) => {
      state.brandDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // AddBrands
    addBrandApiData: (state, { payload }) => {
      state.brandListLoading = true
      state.updateBrandList = false
      state.modalOpen = false
    },
    addBrandApiSuccess: (state, { payload }) => {
      state.updateBrandList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.brandListLoading = false
    },
    addBrandApiFailed: (state, { payload }) => {
      state.updateBrandList = false
      state.brandListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Brands
    updateBrandApiData: (state, { payload }) => {
      state.updateBrandList = false
      state.brandList = state.brandList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateBrandApiSuccess: (state, { payload }) => {
      state.updateBrandList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateBrandApiFailed: (state, { payload }) => {
      state.updateBrandList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Delete Brands
    deleteBrandApiData: (state, { payload }) => {
      let updatedBrandList = state.brandList?.filter((item) => item.id !== payload?.id)
      state.brandList = updatedBrandList
      state.updateBrandList = false
    },
    deleteBrandApiSuccess: (state, { payload }) => {
      state.updateBrandList = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteBrandApiFailed: (state, { payload }) => {
      state.updateBrandList = false
      alert(JSON.stringify(payload, null, 2))
    },

    // List Store Group
    getStoreGroupListApiData: (state, { payload }) => {
      state.storeGroupListLoading = true
    },
    getStoreGroupListApiSuccess: (state, { payload }) => {
      state.storeGroupListLoading = false
      state.storeGroupList = payload?.payload?.data
      state.storeGroupListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStoreGroupListApiFailed: (state, { payload }) => {
      state.storeGroupListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // add store group
    addStoreGroupListApiData: (state, { payload }) => {
      state.storeGroupListLoading = true
      state.updateStoreGroups = false
      state.modalOpen = false
      state.ApiError = ''
    },
    addStoreGroupListApiSuccess: (state, { payload }) => {
      state.updateStoreGroups = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeGroupListLoading = false
    },
    addStoreGroupListApiFailed: (state, { payload }) => {
      state.updateStoreGroups = false
      state.storeGroupListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // update store Group
    updateStoreGroupListApiData: (state, { payload }) => {
      state.updateStoreGroups = false
      state.storeGroupList = state.storeGroupList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreGroupListApiSuccess: (state, { payload }) => {
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.updateStoreGroups = true
    },
    updateStoreGroupListApiFailed: (state, { payload }) => {
      state.updateStoreGroups = false
      alert(JSON.stringify(payload, null, 2))
    },

    // delete Store group
    deleteStoreGroupListApiData: (state, { payload }) => {
      let updatedStoreGroupList = state.storeGroupList?.filter((item) => item.id !== payload?.id)
      state.storeGroupList = updatedStoreGroupList
      state.updateStoreGroups = false
    },
    deleteStoreGroupListApiSuccess: (state, { payload }) => {
      state.updateStoreGroups = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreGroupListApiFailed: (state, { payload }) => {
      state.updateStoreGroups = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Active Inactive Store group
    activeInactiveStoreGroupListApiData: (state, { payload }) => {
      state.updateStoreGroups = false
      state.storeGroupListLoading = true
    },
    activeInactiveStoreGroupListApiSuccess: (state, { payload }) => {
      state.updateStoreGroups = true
      state.storeGroupListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreGroupListApiFailed: (state, { payload }) => {
      state.updateStoreGroups = false
      state.storeGroupListLoading = false
    },

    // store group details
    getStoreGroupDetailsListApiData: (state, { payload }) => {
      state.getStoreGroupsDetailsLoading = true
    },
    getStoreGroupDetailsListApiSuccess: (state, { payload }) => {
      state.getStoreGroupsDetails = payload?.payload?.data
      state.getStoreGroupsDetailsLoading = false
    },
    getStoreGroupDetailsListApiFailed: (state, { payload }) => {
      state.getStoreGroupsDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // store Tags
    getStoreTagListApiData: (state, { payload }) => {
      state.storeTagListLoading = true
    },
    getStoreTagListApiSuccess: (state, { payload }) => {
      state.storeTagListLoading = false
      state.storeTagList = payload?.payload?.data
      state.storeTagListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStoreTagListApiFailed: (state, { payload }) => {
      state.storeTagListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add Store Tags
    addStoreTagApiData: (state, { payload }) => {
      state.storeTagListLoading = true
      state.updateStoreTag = false
      state.modalOpen = false
      state.ApiError = ''
    },
    addStoreTagApiSuccess: (state, { payload }) => {
      state.updateStoreTag = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeTagListLoading = false
    },
    addStoreTagApiFailed: (state, { payload }) => {
      state.updateStoreTag = false
      state.storeTagListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // update Store Tag
    updateStoreTagApiData: (state, { payload }) => {
      state.updateStoreTag = false
      state.storeTagList = state.storeTagList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreTagApiSuccess: (state, { payload }) => {
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.updateStoreTag = true
    },
    updateStoreTagApiFailed: (state, { payload }) => {
      state.updateStoreTag = false
      alert(JSON.stringify(payload, null, 2))
    },

    // delete Store Tag
    deleteStoreTagApiData: (state, { payload }) => {
      let updatedTagList = state.storeTagList?.filter((item) => item.id !== payload?.id)
      state.storeTagList = updatedTagList
      state.updateStoreTag = false
    },
    deleteStoreTagApiSuccess: (state, { payload }) => {
      state.updateStoreTag = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreTagApiFailed: (state, { payload }) => {
      state.updateStoreTag = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Enquiry List
    getEnquiryListApiData: (state, { payload }) => {
      state.enquiryListLoading = true
    },
    getEnquiryListApiSuccess: (state, { payload }) => {
      state.enquiryListLoading = false
      state.enquiryList = payload?.payload?.data || []
      state.enquiryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getEnquiryListApiFailed: (state, { payload }) => {
      state.enquiryListLoading = false
      state.enquiryList = []
      alert(JSON.stringify(payload, null, 2))
    },

    // Enquiry Details
    getEnquiryDetailsListApiData: (state, { payload }) => {
      state.enquiryDetailsLoading = true
    },
    getEnquiryDetailsListApiSuccess: (state, { payload }) => {
      state.enquiryDetails = payload?.payload?.data || {}
      state.enquiryDetailsLoading = false
    },
    getEnquiryDetailsListApiFailed: (state, { payload }) => {
      state.enquiryDetailsLoading = false
      state.enquiryDetails = {}
      alert(JSON.stringify(payload, null, 2))
    },

    // Active InACtive Store Tag
    activeInactiveStoreTagListApiData: (state, { payload }) => {
      state.updateStoreTag = false
      state.storeTagListLoading = true
    },
    activeInactiveStoreTagListApiSuccess: (state, { payload }) => {
      state.updateStoreTag = true
      state.storeTagListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreTagListApiFailed: (state, { payload }) => {
      state.updateStoreTag = false
      state.storeTagListLoading = false
    },

    // Store Roles Active InActive
    activeInactiveStoreRolesListApiData: (state, { payload }) => {
      state.updateRole = false
      state.roleListLoading = true
    },
    activeInactiveStoreRolesListApiSuccess: (state, { payload }) => {
      state.updateRole = true
      state.roleListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreRolesListApiFailed: (state, { payload }) => {
      state.updateRole = false
      state.roleListLoading = false
    },
    // Store Type Active Inactive
    activeInactiveStoreTypeListApiData: (state, { payload }) => {
      state.updateStoreTypes = false
      state.storeTypeListLoading = true
    },
    activeInactiveStoreTypeListApiSuccess: (state, { payload }) => {
      state.updateStoreTypes = true
      state.storeTypeListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreTypeListApiFailed: (state, { payload }) => {
      state.updateStoreTypes = false
      state.storeTypeListLoading = false
    },

    // ================= Video Category List =================
    getStoreVideoCategoryListApiData: (state) => {
      state.storeVideoCategoryListLoading = true
    },
    getStoreVideoCategoryListApiSuccess: (state, { payload }) => {
      state.storeVideoCategoryListLoading = false
      state.storeVideoCategoryList = payload?.payload?.data
      state.storeVideoCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
      }
    },
    getStoreVideoCategoryListApiFailed: (state) => {
      state.storeVideoCategoryListLoading = false
    },

    // ================= Add Video Category =================
    addStoreVideoCategoryApiData: (state) => {
      state.updateStoreVideoCategory = false
      state.storeVideoCategoryListLoading = true
    },
    addStoreVideoCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreVideoCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeVideoCategoryListLoading = false
    },
    addStoreVideoCategoryApiFailed: (state) => {
      state.updateStoreVideoCategory = false
      state.storeVideoCategoryListLoading = false
    },

    // ================= Update Video Category =================
    updateStoreVideoCategoryApiData: (state, { payload }) => {
      state.updateStoreVideoCategory = false
      state.storeVideoCategoryList = state.storeVideoCategoryList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateStoreVideoCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreVideoCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreVideoCategoryApiFailed: (state) => {
      state.updateStoreVideoCategory = false
    },

    // ================= Active / Inactive Video Category =================
    activeInactiveStoreVideoCategoryApiData: (state) => {
      state.updateStoreVideoCategory = false
    },
    activeInactiveStoreVideoCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreVideoCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreVideoCategoryApiFailed: (state) => {
      state.updateStoreVideoCategory = false
    },

    // ================= Store Video List =================
    getStoreVideoListApiData: (state) => {
      state.storeVideoListLoading = true
    },
    getStoreVideoListApiSuccess: (state, { payload }) => {
      state.storeVideoListLoading = false
      state.storeVideoList = payload?.payload?.data
      state.storeVideoPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
      }
    },
    getStoreVideoListApiFailed: (state) => {
      state.storeVideoListLoading = false
    },
    getVideoDetailsData: (state) => {
      state.videoDetailsLoading = true
      state.videoDetails = {}
    },
    getVideoDetailsApiSuccess: (state, { payload }) => {
      state.videoDetailsLoading = false
      state.videoDetails = payload?.payload?.data || {}
    },
    getVideoDetailsApiFailed: (state, { payload }) => {
      state.videoDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
      state.videoDetails = {}
    },

    // ================= Add Store Video =================
    addStoreVideoApiData: (state) => {
      state.updateStoreVideo = false
      state.storeVideoListLoading = true
    },
    addStoreVideoApiSuccess: (state, { payload }) => {
      state.updateStoreVideo = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeVideoListLoading = false
    },
    addStoreVideoApiFailed: (state) => {
      state.updateStoreVideo = false
      state.storeVideoListLoading = false
    },

    // ================= Update Store Video =================
    updateStoreVideoApiData: (state, { payload }) => {
      state.updateStoreVideo = false
      state.storeVideoList = state.storeVideoList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateStoreVideoApiSuccess: (state, { payload }) => {
      state.updateStoreVideo = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreVideoApiFailed: (state) => {
      state.updateStoreVideo = false
    },

    // ================= Active / Inactive =================
    activeInactiveStoreVideoApiData: (state) => {
      state.updateStoreVideo = false
    },
    activeInactiveStoreVideoApiSuccess: (state, { payload }) => {
      state.updateStoreVideo = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreVideoApiFailed: (state) => {
      state.updateStoreVideo = false
    },

    // ================= Offer Category List =================
    getStoreOfferCategoryListApiData: (state) => {
      state.storeOfferCategoryListLoading = true
    },
    getStoreOfferCategoryListApiSuccess: (state, { payload }) => {
      state.storeOfferCategoryListLoading = false
      state.storeOfferCategoryList = payload?.payload?.data || []
      state.storeOfferCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
      }
    },
    getStoreOfferCategoryListApiFailed: (state) => {
      state.storeOfferCategoryListLoading = false
    },

    // ================= Offer Category Details =================
    getStoreOfferCategoryDetailsApiData: (state) => {
      state.storeOfferCategoryDetailsLoading = true
      state.storeOfferCategoryDetails = {}
    },
    getStoreOfferCategoryDetailsApiSuccess: (state, { payload }) => {
      state.storeOfferCategoryDetailsLoading = false
      state.storeOfferCategoryDetails = payload?.payload?.data || {}
    },
    getStoreOfferCategoryDetailsApiFailed: (state, { payload }) => {
      state.storeOfferCategoryDetailsLoading = false
      state.storeOfferCategoryDetails = {}
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Add Offer Category =================
    addStoreOfferCategoryApiData: (state) => {
      state.updateStoreOfferCategory = false
      state.storeOfferCategoryListLoading = true
    },
    addStoreOfferCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreOfferCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.storeOfferCategoryListLoading = false
    },
    addStoreOfferCategoryApiFailed: (state) => {
      state.updateStoreOfferCategory = false
      state.storeOfferCategoryListLoading = false
    },

    // ================= Update Offer Category =================
    updateStoreOfferCategoryApiData: (state, { payload }) => {
      state.updateStoreOfferCategory = false
      state.storeOfferCategoryList = state.storeOfferCategoryList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateStoreOfferCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreOfferCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreOfferCategoryApiFailed: (state) => {
      state.updateStoreOfferCategory = false
    },

    // ================= Active / Inactive Offer Category =================
    activeInactiveStoreOfferCategoryApiData: (state) => {
      state.updateStoreOfferCategory = false
    },
    activeInactiveStoreOfferCategoryApiSuccess: (state, { payload }) => {
      state.updateStoreOfferCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreOfferCategoryApiFailed: (state) => {
      state.updateStoreOfferCategory = false
    },

    // ================= Store Offer List =================
    getStoreOfferListApiData: (state) => {
      state.storeOfferListLoading = true
    },

    getStoreOfferListApiSuccess: (state, { payload }) => {
      state.storeOfferListLoading = false
      state.storeOfferList = payload?.payload?.data || []
      state.storeOfferPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },

    getStoreOfferListApiFailed: (state) => {
      state.storeOfferListLoading = false
    },
    // ================= Store Offer Details =================
    getStoreOfferDetailsApiData: (state) => {
      state.storeOfferDetailsLoading = true
      state.storeOfferDetails = {}
    },

    getStoreOfferDetailsApiSuccess: (state, { payload }) => {
      state.storeOfferDetailsLoading = false
      state.storeOfferDetails = payload?.payload?.data || {}
    },

    getStoreOfferDetailsApiFailed: (state) => {
      state.storeOfferDetailsLoading = false
    },

    // ================= UPDATE OFFER =================
    updateOfferApiData: (state) => {
      state.updateOfferLoading = true
      state.updateOfferSuccess = false
    },
    updateOfferApiSuccess: (state, { payload }) => {
      state.updateOfferLoading = false
      state.updateOfferSuccess = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateOfferApiFailed: (state, { payload }) => {
      state.updateOfferLoading = false
      state.ApiError = payload
      alert(JSON.stringify(payload, null, 2))
    },

    // LIST
    getOfferSubCategoryListApiData: (state) => {
      state.offerSubCategoryLoading = true
    },
    getOfferSubCategoryListApiSuccess: (state, { payload }) => {
      state.offerSubCategoryLoading = false
      state.offerSubCategoryList = payload.data
      state.offerSubCategoryPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
      }
    },
    getOfferSubCategoryListApiFailed: (state, { payload }) => {
      state.offerSubCategoryLoading = false
      state.ApiError = payload
      //alert(JSON.stringify(payload, null, 2))
    },

    // ================= OFFER SUB CATEGORY DETAILS =================

    getOfferSubCategoryDetailsApiData: (state) => {
      state.offerSubCategoryDetailsLoading = true
    },

    getOfferSubCategoryDetailsApiSuccess: (state, { payload }) => {
      state.offerSubCategoryDetailsLoading = false
      state.offerSubCategoryDetails = payload.data
    },

    getOfferSubCategoryDetailsApiFailed: (state, { payload }) => {
      state.offerSubCategoryDetailsLoading = false
      state.ApiError = payload
    },

    // ADD
    addOfferSubCategoryApiData: (state) => {
      state.updateOfferSubCategory = false
      state.modalOpen = false
    },
    addOfferSubCategoryApiSuccess: (state, { payload }) => {
      state.updateOfferSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    addOfferSubCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
      state.modalOpen = false
      alert(JSON.stringify(payload, null, 2))
    },

    // UPDATE
    updateOfferSubCategoryApiData: (state) => {
      state.updateOfferSubCategory = false
      state.modalOpen = false
    },
    updateOfferSubCategoryApiSuccess: (state, { payload }) => {
      state.updateOfferSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateOfferSubCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
      state.modalOpen = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ACTIVE / INACTIVE
    activeInactiveOfferSubCategoryApiData: (state) => {
      state.offerSubCategoryLoading = true
      state.updateOfferSubCategory = false
    },
    activeInactiveOfferSubCategoryApiSuccess: (state, { payload }) => {
      state.offerSubCategoryLoading = false
      state.updateOfferSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    activeInactiveOfferSubCategoryApiFailed: (state, { payload }) => {
      state.offerSubCategoryLoading = false
      state.ApiError = payload

      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship Super Category =================
    getInternshipSuperCategoryListApiData: (state) => {
      state.internshipSuperCategoryLoading = true
    },
    getInternshipSuperCategoryListApiSuccess: (state, { payload }) => {
      state.internshipSuperCategoryLoading = false
      state.internshipSuperCategoryList = payload?.payload?.data || []
      state.internshipSuperCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getInternshipSuperCategoryListApiFailed: (state, { payload }) => {
      state.internshipSuperCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    getInternshipSuperCategoryDetailsApiData: (state) => {
      state.internshipSuperCategoryDetailsLoading = true
    },
    getInternshipSuperCategoryDetailsApiSuccess: (state, { payload }) => {
      state.internshipSuperCategoryDetails = payload?.payload?.data || {}
      state.internshipSuperCategoryDetailsLoading = false
    },
    getInternshipSuperCategoryDetailsApiFailed: (state, { payload }) => {
      state.internshipSuperCategoryDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addInternshipSuperCategoryApiData: (state) => {
      state.internshipSuperCategoryLoading = true
      state.updateInternshipSuperCategory = false
      state.modalOpen = false
    },
    addInternshipSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipSuperCategoryLoading = false
    },
    addInternshipSuperCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSuperCategory = false
      state.internshipSuperCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateInternshipSuperCategoryApiData: (state, { payload }) => {
      state.updateInternshipSuperCategory = false
      state.internshipSuperCategoryList = state.internshipSuperCategoryList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateInternshipSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateInternshipSuperCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSuperCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    deleteInternshipSuperCategoryApiData: (state, { payload }) => {
      let updatedList = state.internshipSuperCategoryList?.filter((item) => item.id !== payload?.id)
      state.internshipSuperCategoryList = updatedList
      state.updateInternshipSuperCategory = false
    },
    deleteInternshipSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteInternshipSuperCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSuperCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveInternshipSuperCategoryApiData: (state) => {
      state.updateInternshipSuperCategory = false
      state.internshipSuperCategoryLoading = true
    },
    activeInactiveInternshipSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSuperCategory = true
      state.internshipSuperCategoryLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveInternshipSuperCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSuperCategory = false
      state.internshipSuperCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship Category =================
    getInternshipCategoryListApiData: (state) => {
      state.internshipCategoryListLoading = true
    },
    getInternshipCategoryListApiSuccess: (state, { payload }) => {
      state.internshipCategoryListLoading = false
      state.internshipCategoryList = payload?.payload?.data || []
      state.internshipCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getInternshipCategoryListApiFailed: (state, { payload }) => {
      state.internshipCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addInternshipCategoryApiData: (state) => {
      state.internshipCategoryListLoading = true
      state.updateInternshipCategory = false
      state.modalOpen = false
    },
    addInternshipCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipCategoryListLoading = false
    },
    addInternshipCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipCategory = false
      state.internshipCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateInternshipCategoryApiData: (state) => {
      state.updateInternshipCategory = false
      state.internshipCategoryListLoading = true
    },
    updateInternshipCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipCategoryListLoading = false
    },
    updateInternshipCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipCategory = false
      state.internshipCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveInternshipCategoryApiData: (state) => {
      state.updateInternshipCategory = false
      state.internshipCategoryListLoading = true
    },
    activeInactiveInternshipCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipCategoryListLoading = false
    },
    activeInactiveInternshipCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipCategory = false
      state.internshipCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship Category Delete =================
    deleteInternshipCategoryApiData: (state, { payload }) => {
      let updatedList = state.internshipCategoryList?.filter((item) => item.id !== payload?.id)
      state.internshipCategoryList = updatedList
      state.updateInternshipCategory = false
    },
    deleteInternshipCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteInternshipCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship SubCategory =================
    getInternshipSubCategoryListApiData: (state) => {
      state.internshipSubCategoryLoading = true
    },
    getInternshipSubCategoryListApiSuccess: (state, { payload }) => {
      state.internshipSubCategoryLoading = false
      state.internshipSubCategoryList = payload?.payload?.data || []
      state.internshipSubCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getInternshipSubCategoryListApiFailed: (state, { payload }) => {
      state.internshipSubCategoryLoading = false
    },

    addInternshipSubCategoryApiData: (state) => {
      state.internshipSubCategoryLoading = true
      state.updateInternshipSubCategory = false
      state.modalOpen = false
    },
    addInternshipSubCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipSubCategoryLoading = false
    },
    addInternshipSubCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSubCategory = false
      state.internshipSubCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateInternshipSubCategoryApiData: (state) => {
      state.updateInternshipSubCategory = false
      state.internshipSubCategoryLoading = true
    },
    updateInternshipSubCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipSubCategoryLoading = false
    },
    updateInternshipSubCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSubCategory = false
      state.internshipSubCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveInternshipSubCategoryApiData: (state) => {
      state.updateInternshipSubCategory = false
      state.internshipSubCategoryLoading = true
    },
    activeInactiveInternshipSubCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.internshipSubCategoryLoading = false
    },
    activeInactiveInternshipSubCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSubCategory = false
      state.internshipSubCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship SubCategory Delete =================
    deleteInternshipSubCategoryApiData: (state, { payload }) => {
      let updatedList = state.internshipSubCategoryList?.filter((item) => item.id !== payload?.id)
      state.internshipSubCategoryList = updatedList
      state.updateInternshipSubCategory = false
    },
    deleteInternshipSubCategoryApiSuccess: (state, { payload }) => {
      state.updateInternshipSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteInternshipSubCategoryApiFailed: (state, { payload }) => {
      state.updateInternshipSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship Programs =================
    getInternshipProgramListApiData: (state) => {
      state.internshipProgramListLoading = true
    },
    getInternshipProgramListApiSuccess: (state, { payload }) => {
      state.internshipProgramListLoading = false
      state.internshipProgramList = payload?.payload?.data || []
      state.internshipProgramPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getInternshipProgramListApiFailed: (state, { payload }) => {
      state.internshipProgramListLoading = false
    },

    getInternshipProgramDetailsApiData: (state) => {
      state.internshipProgramDetailsLoading = true
    },
    getInternshipProgramDetailsApiSuccess: (state, { payload }) => {
      state.internshipProgramDetails = payload?.payload?.data || {}
      state.internshipProgramDetailsLoading = false
    },
    getInternshipProgramDetailsApiFailed: (state, { payload }) => {
      state.internshipProgramDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Internship Program Delete =================
    deleteInternshipProgramApiData: (state, { payload }) => {
      let updatedList = state.internshipProgramList?.filter((item) => item.id !== payload?.id)
      state.internshipProgramList = updatedList
    },
    deleteInternshipProgramApiSuccess: (state, { payload }) => {
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteInternshipProgramApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Applied Internship =================
    getAppliedInternshipListApiData: (state) => {
      state.appliedInternshipLoading = true
    },
    getAppliedInternshipListApiSuccess: (state, { payload }) => {
      state.appliedInternshipLoading = false
      state.appliedInternshipList = payload?.payload?.data || []
      state.appliedInternshipPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getAppliedInternshipListApiFailed: (state, { payload }) => {
      state.appliedInternshipLoading = false
    },
    // ================= Skill Program =================

    // -------- Program Types --------
    getSkillProgramTypesListApiData: (state) => {
      state.skillProgramTypesLoading = true
    },
    getSkillProgramTypesListApiSuccess: (state, { payload }) => {
      state.skillProgramTypesLoading = false
      state.skillProgramTypesList = payload?.payload?.data || []
      state.skillProgramTypesPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSkillProgramTypesListApiFailed: (state, { payload }) => {
      state.skillProgramTypesLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addSkillProgramTypesApiData: (state) => {
      state.skillProgramTypesLoading = true
      state.updateSkillProgramTypes = false
      state.modalOpen = false
    },
    addSkillProgramTypesApiSuccess: (state, { payload }) => {
      state.updateSkillProgramTypes = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.skillProgramTypesLoading = false
    },
    addSkillProgramTypesApiFailed: (state, { payload }) => {
      state.updateSkillProgramTypes = false
      state.skillProgramTypesLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateSkillProgramTypesApiData: (state, { payload }) => {
      state.updateSkillProgramTypes = false
      state.skillProgramTypesList = state.skillProgramTypesList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateSkillProgramTypesApiSuccess: (state, { payload }) => {
      state.updateSkillProgramTypes = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateSkillProgramTypesApiFailed: (state, { payload }) => {
      state.updateSkillProgramTypes = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveSkillProgramTypesApiData: (state) => {
      state.updateSkillProgramTypes = false
      state.skillProgramTypesLoading = true
    },
    activeInactiveSkillProgramTypesApiSuccess: (state, { payload }) => {
      state.updateSkillProgramTypes = true
      state.skillProgramTypesLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveSkillProgramTypesApiFailed: (state, { payload }) => {
      state.updateSkillProgramTypes = false
      state.skillProgramTypesLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Skill Program Type Delete =================
    deleteSkillProgramTypesApiData: (state, { payload }) => {
      let updatedList = state.skillProgramTypesList?.filter((item) => item.id !== payload?.id)
      state.skillProgramTypesList = updatedList
      state.updateSkillProgramTypes = false
    },
    deleteSkillProgramTypesApiSuccess: (state, { payload }) => {
      state.updateSkillProgramTypes = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteSkillProgramTypesApiFailed: (state, { payload }) => {
      state.updateSkillProgramTypes = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Skill Super Category =================
    getSkillSuperCategoryListApiData: (state) => {
      state.skillSuperCategoryLoading = true
    },
    getSkillSuperCategoryListApiSuccess: (state, { payload }) => {
      state.skillSuperCategoryLoading = false
      state.skillSuperCategoryList = payload?.payload?.data || []
      state.skillSuperCategoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSkillSuperCategoryListApiFailed: (state, { payload }) => {
      state.skillSuperCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    getSkillSuperCategoryDetailsApiData: (state) => {
      state.skillSuperCategoryDetailsLoading = true
    },
    getSkillSuperCategoryDetailsApiSuccess: (state, { payload }) => {
      state.skillSuperCategoryDetails = payload?.payload?.data || {}
      state.skillSuperCategoryDetailsLoading = false
    },
    getSkillSuperCategoryDetailsApiFailed: (state, { payload }) => {
      state.skillSuperCategoryDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addSkillSuperCategoryApiData: (state) => {
      state.skillSuperCategoryLoading = true
      state.updateSkillSuperCategory = false
      state.modalOpen = false
    },
    addSkillSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.skillSuperCategoryLoading = false
    },
    addSkillSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSuperCategory = false
      state.skillSuperCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateSkillSuperCategoryApiData: (state, { payload }) => {
      state.updateSkillSuperCategory = false
      state.skillSuperCategoryList = state.skillSuperCategoryList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateSkillSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateSkillSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSuperCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    deleteSkillSuperCategoryApiData: (state, { payload }) => {
      let updatedList = state.skillSuperCategoryList?.filter((item) => item.id !== payload?.id)
      state.skillSuperCategoryList = updatedList
      state.updateSkillSuperCategory = false
    },
    deleteSkillSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteSkillSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSuperCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveSkillSuperCategoryApiData: (state) => {
      state.updateSkillSuperCategory = false
      state.skillSuperCategoryLoading = true
    },
    activeInactiveSkillSuperCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSuperCategory = true
      state.skillSuperCategoryLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveSkillSuperCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSuperCategory = false
      state.skillSuperCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // -------- Category --------
    getSkillCategoryListApiData: (state) => {
      state.skillCategoryLoading = true
    },
    getSkillCategoryListApiSuccess: (state, { payload }) => {
      state.skillCategoryLoading = false
      state.skillCategoryList = payload?.payload?.data || []
      state.skillCategoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSkillCategoryListApiFailed: (state, { payload }) => {
      state.skillCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addSkillCategoryApiData: (state) => {
      state.skillCategoryLoading = true
      state.updateSkillCategory = false
      state.modalOpen = false
    },
    addSkillCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.skillCategoryLoading = false
    },
    addSkillCategoryApiFailed: (state, { payload }) => {
      state.updateSkillCategory = false
      state.skillCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateSkillCategoryApiData: (state, { payload }) => {
      state.updateSkillCategory = false
      state.skillCategoryList = state.skillCategoryList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateSkillCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateSkillCategoryApiFailed: (state, { payload }) => {
      state.updateSkillCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveSkillCategoryApiData: (state) => {
      state.updateSkillCategory = false
      state.skillCategoryLoading = true
    },
    activeInactiveSkillCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillCategory = true
      state.skillCategoryLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveSkillCategoryApiFailed: (state, { payload }) => {
      state.updateSkillCategory = false
      state.skillCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Skill Category Delete =================
    deleteSkillCategoryApiData: (state, { payload }) => {
      let updatedList = state.skillCategoryList?.filter((item) => item.id !== payload?.id)
      state.skillCategoryList = updatedList
      state.updateSkillCategory = false
    },
    deleteSkillCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteSkillCategoryApiFailed: (state, { payload }) => {
      state.updateSkillCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // -------- Sub Category --------
    getSkillSubCategoryListApiData: (state) => {
      state.skillSubCategoryLoading = true
    },
    getSkillSubCategoryListApiSuccess: (state, { payload }) => {
      state.skillSubCategoryLoading = false
      state.skillSubCategoryList = payload?.payload?.data || []
      state.skillSubCategoryPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSkillSubCategoryListApiFailed: (state, { payload }) => {
      state.skillSubCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addSkillSubCategoryApiData: (state) => {
      state.skillSubCategoryLoading = true
      state.updateSkillSubCategory = false
      state.modalOpen = false
    },
    addSkillSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.skillSubCategoryLoading = false
    },
    addSkillSubCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSubCategory = false
      state.skillSubCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateSkillSubCategoryApiData: (state, { payload }) => {
      state.updateSkillSubCategory = false
      state.skillSubCategoryList = state.skillSubCategoryList.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item,
      )
    },
    updateSkillSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateSkillSubCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    activeInactiveSkillSubCategoryApiData: (state) => {
      state.updateSkillSubCategory = false
      state.skillSubCategoryLoading = true
    },
    activeInactiveSkillSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSubCategory = true
      state.skillSubCategoryLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveSkillSubCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSubCategory = false
      state.skillSubCategoryLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Skill SubCategory Delete =================
    deleteSkillSubCategoryApiData: (state, { payload }) => {
      let updatedList = state.skillSubCategoryList?.filter((item) => item.id !== payload?.id)
      state.skillSubCategoryList = updatedList
      state.updateSkillSubCategory = false
    },
    deleteSkillSubCategoryApiSuccess: (state, { payload }) => {
      state.updateSkillSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteSkillSubCategoryApiFailed: (state, { payload }) => {
      state.updateSkillSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    getSkillProgramListApiData: (state) => {
      state.skillProgramLoading = true
    },
    getSkillProgramListApiSuccess: (state, { payload }) => {
      state.skillProgramLoading = false
      state.skillProgramList = payload?.payload?.data || []
      state.skillProgramPagination = {
        total: payload?.payload?.total || 0,
        page: payload?.payload?.page || 1,
        size: payload?.payload?.size || 10,
      }
    },
    getSkillProgramListApiFailed: (state, { payload }) => {
      state.skillProgramLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // DETAILS
    getSkillProgramDetailsApiData: (state) => {
      state.skillProgramDetailsLoading = true
    },
    getSkillProgramDetailsApiSuccess: (state, { payload }) => {
      state.skillProgramDetailsLoading = false
      state.skillProgramDetails = payload?.payload || null
    },
    getSkillProgramDetailsApiFailed: (state, { payload }) => {
      state.skillProgramDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= Skill Program Delete =================
    deleteSkillProgramApiData: (state, { payload }) => {
      let updatedList = state.skillProgramList?.filter((item) => item.id !== payload?.id)
      state.skillProgramList = updatedList
    },
    deleteSkillProgramApiSuccess: (state, { payload }) => {
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteSkillProgramApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    getAppliedSkillListApiData: (state) => {
      state.appliedSkillLoading = true
    },
    getAppliedSkillListApiSuccess: (state, { payload }) => {
      state.appliedSkillLoading = false
      state.appliedSkillList = payload?.payload?.data
      state.appliedSkillPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
      }
    },
    getAppliedSkillListApiFailed: (state) => {
      state.appliedSkillLoading = false
    },

    getAppliedSkillDetailsApiData: (state) => {
      state.appliedSkillDetailsLoading = true
    },
    getAppliedSkillDetailsApiSuccess: (state, { payload }) => {
      state.appliedSkillDetails = payload?.payload?.data
      state.appliedSkillDetailsLoading = false
    },
    getAppliedSkillDetailsApiFailed: (state) => {
      state.appliedSkillDetailsLoading = false
    },

    resetManageStoreError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // Store Roles
  storeRolesListApiData,
  storeRolesListApiSuccess,
  storeRolesListApiFailed,

  // Add store roles
  addStoreRolesApiData,
  addStoreRolesApiSuccess,
  addStoreRolesApiFailed,

  // Update Store Roles
  updateStoreRolesApiData,
  updateStoreRolesApiSuccess,
  updateStoreRolesApiFailed,
  // List Store Group
  getStoreGroupListApiData,
  getStoreGroupListApiSuccess,
  getStoreGroupListApiFailed,

  // add store group
  addStoreGroupListApiData,
  addStoreGroupListApiSuccess,
  addStoreGroupListApiFailed,

  // update store Group
  updateStoreGroupListApiData,
  updateStoreGroupListApiSuccess,
  updateStoreGroupListApiFailed,

  // delete Store group
  deleteStoreGroupListApiData,
  deleteStoreGroupListApiSuccess,
  deleteStoreGroupListApiFailed,

  // delete Store group
  activeInactiveStoreGroupListApiData,
  activeInactiveStoreGroupListApiSuccess,
  activeInactiveStoreGroupListApiFailed,

  // store group details
  getStoreGroupDetailsListApiData,
  getStoreGroupDetailsListApiSuccess,
  getStoreGroupDetailsListApiFailed,

  // Store Type
  getStoreTypeListApiData,
  getStoreTypeListApiDataSuccess,
  getStoreTypeListApiDataFailed,
  // add Store Type
  addStoreTypeListApiData,
  addStoreTypeListApiSuccess,
  addStoreTypeListApiFailed,
  // Update Store Type
  updateStoreTypeListApiData,
  updateStoreTypeListApiSuccess,
  updateStoreTypeListApiFailed,
  //delete Store Type
  deleteStoreTypeListApiData,
  deleteStoreTypeListApiSuccess,
  deleteStoreTypeListApiFailed,
  // details Store type
  getStoreTypeDetailsListApiData,
  getStoreTypeDetailsListApiSuccess,
  getStoreTypeDetailsListApiFailed,

  // store Categories List
  storeCategoryListApiData,
  storeCategoryListApiSuccess,
  storeCategoryListApiFailed,

  // store Categories List Details
  storeCategoryDetailsApiData,
  storeCategoryDetailsApiSuccess,
  storeCategoryDetailsApiFailed,

  // Add Store category in List
  addStoreCategoryApiData,
  addStoreCategoryApiSuccess,
  addStoreCategoryApiFailed,

  // Update Store Category
  updateStoreCategoryListApiData,
  updateStoreCategoryApiSuccess,
  updateStoreCategoryApiFailed,

  // delete Category
  deleteStoreProductCategoryDataApiData,
  deleteStoreProductCategoryDataApiSuccess,
  deleteStoreProductCategoryDataApiFailed,

  // store Sub Category List
  storeSubCategoryListApiData,
  storeSubCategoryListApiSuccess,
  storeSubCategoryListApiFailed,

  // store Sub Category Details
  storeSubCategoryDetailsApiData,
  storeSubCategoryDetailsApiSuccess,
  storeSubCategoryDetailsApiFailed,

  // Add Sub Category
  addSubStoreCategoryApiData,
  addSubStoreCategoryApiSuccess,
  addSubStoreCategoryApiFailed,

  // Update Store Sub Category
  updateStoreSubCategoryListApiData,
  updateStoreSubCategoryListApiSuccess,
  updateStoreSubCategoryListApiFailed,

  // delete Sub Category Store
  deleteStoreSubProductCategoryApiData,
  deleteStoreSubProductCategoryApiSuccess,
  deleteStoreSubProductCategoryApiFailed,

  // Child Sub Category

  // Child SubCategory List
  storeProductSubChildCategoriesListApiData,
  storeProductSubChildCategoriesListApiSuccess,
  storeProductSubChildCategoriesListApiFailed,

  //Child SubCategory List Details
  storeProductSubChildCategoriesItemDetailsApiData,
  storeProductSubChildCategoriesItemDetailsApiSuccess,
  storeProductSubChildCategoriesItemDetailsApiFailed,

  // Add Store Child Sub Category
  addStoreProductChildSubCategoryApiData,
  addStoreProductChildSubCategoryApiSuccess,
  addStoreProductChildSubCategoryApiFailed,
  // Update Store Child Sub Category
  updateStoreChildSubCategoryListApiData,
  updateStoreChildSubCategoryListApiSuccess,
  updateStoreChildSubCategoryListApiFailed,
  // Delete Child Category
  deleteStoreProductChildSubCategoryApiData,
  deleteStoreProductChildSubCategoryApiSuccess,
  deleteStoreProductChildSubCategoryApiFailed,

  // Admin Brand
  // Brands
  brandListApiData,
  brandListApiSuccess,
  brandListApiFailed,
  // Brands details
  brandNameDetailsApiData,
  brandNameDetailsApiSuccess,
  brandNameDetailsApiFailed,

  // AddBrands
  addBrandApiData,
  addBrandApiSuccess,
  addBrandApiFailed,

  // Update Brands
  updateBrandApiData,
  updateBrandApiSuccess,
  updateBrandApiFailed,

  // Delete Brands
  deleteBrandApiData,
  deleteBrandApiSuccess,
  deleteBrandApiFailed,

  // store Tags
  getStoreTagListApiData,
  getStoreTagListApiSuccess,
  getStoreTagListApiFailed,

  // Add Store Tags
  addStoreTagApiData,
  addStoreTagApiSuccess,
  addStoreTagApiFailed,

  // update Store Tag
  updateStoreTagApiData,
  updateStoreTagApiSuccess,
  updateStoreTagApiFailed,

  // delete Store Tag
  deleteStoreTagApiData,
  deleteStoreTagApiSuccess,
  deleteStoreTagApiFailed,

  // Active InACtive Store Tag
  activeInactiveStoreTagListApiData,
  activeInactiveStoreTagListApiSuccess,
  activeInactiveStoreTagListApiFailed,

  // Store Roles Active InActive
  activeInactiveStoreRolesListApiData,
  activeInactiveStoreRolesListApiSuccess,
  activeInactiveStoreRolesListApiFailed,
  // Store Type Active Inactive
  activeInactiveStoreTypeListApiData,
  activeInactiveStoreTypeListApiSuccess,
  activeInactiveStoreTypeListApiFailed,

  // Enquiry List
  getEnquiryListApiData,
  getEnquiryListApiSuccess,
  getEnquiryListApiFailed,

  // Enquiry List Details
  getEnquiryDetailsListApiData,
  getEnquiryDetailsListApiSuccess,
  getEnquiryDetailsListApiFailed,

  getStoreVideoCategoryListApiData,
  getStoreVideoCategoryListApiSuccess,
  getStoreVideoCategoryListApiFailed,

  addStoreVideoCategoryApiData,
  addStoreVideoCategoryApiSuccess,
  addStoreVideoCategoryApiFailed,

  updateStoreVideoCategoryApiData,
  updateStoreVideoCategoryApiSuccess,
  updateStoreVideoCategoryApiFailed,

  activeInactiveStoreVideoCategoryApiData,
  activeInactiveStoreVideoCategoryApiSuccess,
  activeInactiveStoreVideoCategoryApiFailed,

  getStoreVideoListApiData,
  getStoreVideoListApiSuccess,
  getStoreVideoListApiFailed,

  addStoreVideoApiData,
  addStoreVideoApiSuccess,
  addStoreVideoApiFailed,

  updateStoreVideoApiData,
  updateStoreVideoApiSuccess,
  updateStoreVideoApiFailed,

  activeInactiveStoreVideoApiData,
  activeInactiveStoreVideoApiSuccess,
  activeInactiveStoreVideoApiFailed,

  getVideoDetailsData,
  getVideoDetailsApiSuccess,
  getVideoDetailsApiFailed,

  getStoreOfferCategoryListApiData,
  getStoreOfferCategoryListApiSuccess,
  getStoreOfferCategoryListApiFailed,

  getStoreOfferCategoryDetailsApiData,
  getStoreOfferCategoryDetailsApiSuccess,
  getStoreOfferCategoryDetailsApiFailed,

  addStoreOfferCategoryApiData,
  addStoreOfferCategoryApiSuccess,
  addStoreOfferCategoryApiFailed,

  updateStoreOfferCategoryApiData,
  updateStoreOfferCategoryApiSuccess,
  updateStoreOfferCategoryApiFailed,

  activeInactiveStoreOfferCategoryApiData,
  activeInactiveStoreOfferCategoryApiSuccess,
  activeInactiveStoreOfferCategoryApiFailed,

  getStoreOfferListApiData,
  getStoreOfferListApiSuccess,
  getStoreOfferListApiFailed,
  getStoreOfferDetailsApiData,
  getStoreOfferDetailsApiSuccess,
  getStoreOfferDetailsApiFailed,
  updateOfferApiData,
  updateOfferApiSuccess,
  updateOfferApiFailed,

  getOfferSubCategoryListApiData,
  getOfferSubCategoryListApiSuccess,
  getOfferSubCategoryListApiFailed,
  addOfferSubCategoryApiData,
  addOfferSubCategoryApiSuccess,
  addOfferSubCategoryApiFailed,
  updateOfferSubCategoryApiData,
  updateOfferSubCategoryApiSuccess,
  updateOfferSubCategoryApiFailed,
  activeInactiveOfferSubCategoryApiData,
  activeInactiveOfferSubCategoryApiSuccess,
  activeInactiveOfferSubCategoryApiFailed,
  getOfferSubCategoryDetailsApiData,
  getOfferSubCategoryDetailsApiSuccess,
  getOfferSubCategoryDetailsApiFailed,

  // ================= Internship Super  Category =================

  getInternshipSuperCategoryListApiData,
  getInternshipSuperCategoryListApiSuccess,
  getInternshipSuperCategoryListApiFailed,
  getInternshipSuperCategoryDetailsApiData,
  getInternshipSuperCategoryDetailsApiSuccess,
  getInternshipSuperCategoryDetailsApiFailed,
  addInternshipSuperCategoryApiData,
  addInternshipSuperCategoryApiSuccess,
  addInternshipSuperCategoryApiFailed,
  updateInternshipSuperCategoryApiData,
  updateInternshipSuperCategoryApiSuccess,
  updateInternshipSuperCategoryApiFailed,
  deleteInternshipSuperCategoryApiData,
  deleteInternshipSuperCategoryApiSuccess,
  deleteInternshipSuperCategoryApiFailed,
  activeInactiveInternshipSuperCategoryApiData,
  activeInactiveInternshipSuperCategoryApiSuccess,
  activeInactiveInternshipSuperCategoryApiFailed,

  // ================= Internship Category =================
  getInternshipCategoryListApiData,
  getInternshipCategoryListApiSuccess,
  getInternshipCategoryListApiFailed,
  addInternshipCategoryApiData,
  addInternshipCategoryApiSuccess,
  addInternshipCategoryApiFailed,
  updateInternshipCategoryApiData,
  updateInternshipCategoryApiSuccess,
  updateInternshipCategoryApiFailed,
  activeInactiveInternshipCategoryApiData,
  activeInactiveInternshipCategoryApiSuccess,
  activeInactiveInternshipCategoryApiFailed,

  // ================= Internship SubCategory =================
  getInternshipSubCategoryListApiData,
  getInternshipSubCategoryListApiSuccess,
  getInternshipSubCategoryListApiFailed,
  addInternshipSubCategoryApiData,
  addInternshipSubCategoryApiSuccess,
  addInternshipSubCategoryApiFailed,
  updateInternshipSubCategoryApiData,
  updateInternshipSubCategoryApiSuccess,
  updateInternshipSubCategoryApiFailed,
  activeInactiveInternshipSubCategoryApiData,
  activeInactiveInternshipSubCategoryApiSuccess,
  activeInactiveInternshipSubCategoryApiFailed,

  // ================= Internship Programs =================
  getInternshipProgramListApiData,
  getInternshipProgramListApiSuccess,
  getInternshipProgramListApiFailed,
  getInternshipProgramDetailsApiData,
  getInternshipProgramDetailsApiSuccess,
  getInternshipProgramDetailsApiFailed,

  // ================= Applied Internship =================
  getAppliedInternshipListApiData,
  getAppliedInternshipListApiSuccess,
  getAppliedInternshipListApiFailed,

  // Skill Program
  getSkillProgramTypesListApiData,
  getSkillProgramTypesListApiSuccess,
  getSkillProgramTypesListApiFailed,

  addSkillProgramTypesApiData,
  addSkillProgramTypesApiSuccess,
  addSkillProgramTypesApiFailed,

  updateSkillProgramTypesApiData,
  updateSkillProgramTypesApiSuccess,
  updateSkillProgramTypesApiFailed,

  activeInactiveSkillProgramTypesApiData,
  activeInactiveSkillProgramTypesApiSuccess,
  activeInactiveSkillProgramTypesApiFailed,

  getSkillSuperCategoryListApiData,
  getSkillSuperCategoryListApiSuccess,
  getSkillSuperCategoryListApiFailed,

  getSkillSuperCategoryDetailsApiData,
  getSkillSuperCategoryDetailsApiSuccess,
  getSkillSuperCategoryDetailsApiFailed,

  addSkillSuperCategoryApiData,
  addSkillSuperCategoryApiSuccess,
  addSkillSuperCategoryApiFailed,

  updateSkillSuperCategoryApiData,
  updateSkillSuperCategoryApiSuccess,
  updateSkillSuperCategoryApiFailed,

  deleteSkillSuperCategoryApiData,
  deleteSkillSuperCategoryApiSuccess,
  deleteSkillSuperCategoryApiFailed,

  activeInactiveSkillSuperCategoryApiData,
  activeInactiveSkillSuperCategoryApiSuccess,
  activeInactiveSkillSuperCategoryApiFailed,

  getSkillCategoryListApiData,
  getSkillCategoryListApiSuccess,
  getSkillCategoryListApiFailed,

  addSkillCategoryApiData,
  addSkillCategoryApiSuccess,
  addSkillCategoryApiFailed,

  updateSkillCategoryApiData,
  updateSkillCategoryApiSuccess,
  updateSkillCategoryApiFailed,

  activeInactiveSkillCategoryApiData,
  activeInactiveSkillCategoryApiSuccess,
  activeInactiveSkillCategoryApiFailed,

  getSkillSubCategoryListApiData,
  getSkillSubCategoryListApiSuccess,
  getSkillSubCategoryListApiFailed,

  addSkillSubCategoryApiData,
  addSkillSubCategoryApiSuccess,
  addSkillSubCategoryApiFailed,

  updateSkillSubCategoryApiData,
  updateSkillSubCategoryApiSuccess,
  updateSkillSubCategoryApiFailed,

  activeInactiveSkillSubCategoryApiData,
  activeInactiveSkillSubCategoryApiSuccess,
  activeInactiveSkillSubCategoryApiFailed,

  getSkillProgramListApiData,
  getSkillProgramListApiSuccess,
  getSkillProgramListApiFailed,

  getSkillProgramDetailsApiData,
  getSkillProgramDetailsApiSuccess,
  getSkillProgramDetailsApiFailed,

  getAppliedSkillListApiData,
  getAppliedSkillListApiSuccess,
  getAppliedSkillListApiFailed,

  getAppliedSkillDetailsApiData,
  getAppliedSkillDetailsApiSuccess,
  getAppliedSkillDetailsApiFailed,

  deleteInternshipCategoryApiData,
  deleteInternshipCategoryApiSuccess,
  deleteInternshipCategoryApiFailed,
  deleteInternshipSubCategoryApiData,
  deleteInternshipSubCategoryApiSuccess,
  deleteInternshipSubCategoryApiFailed,
  deleteInternshipProgramApiData,
  deleteInternshipProgramApiSuccess,
  deleteInternshipProgramApiFailed,
  deleteSkillProgramTypesApiData,
  deleteSkillProgramTypesApiSuccess,
  deleteSkillProgramTypesApiFailed,
  deleteSkillCategoryApiData,
  deleteSkillCategoryApiSuccess,
  deleteSkillCategoryApiFailed,
  deleteSkillSubCategoryApiData,
  deleteSkillSubCategoryApiSuccess,
  deleteSkillSubCategoryApiFailed,
  deleteSkillProgramApiData,
  deleteSkillProgramApiSuccess,
  deleteSkillProgramApiFailed,

  // reset
  resetManageStoreError,
} = slice.actions

export default slice.reducer
